import React from 'react';
import { Button, Stack, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

import ReferralRouteShell from './ReferralRouteShell';

const AdminIndexPage: React.FC = () => (
  <ReferralRouteShell backTo="/dashboard" maxWidth={false} title="Admin">
    <Stack spacing={2}>
      <Typography>
        Choose an admin referral list. These routes stay hidden from the normal dashboard UI.
      </Typography>
      {/* REQ-026: /admins should act as a hidden admin index instead of dropping straight into group 1 data. */}
      <Button component={RouterLink} to="/admins/group-1" variant="quiet" color="primary">
        All Referrals Group 1
      </Button>
      <Button component={RouterLink} to="/admins/group-2" variant="quiet" color="primary">
        All Referrals Group 2
      </Button>
      {/* REQ-029: hidden admin index links directly to group-scoped user activity pages. */}
      <Button component={RouterLink} to="/admins/group-1/activity" variant="quiet" color="primary">
        Group 1 User Activity
      </Button>
      <Button component={RouterLink} to="/admins/group-2/activity" variant="quiet" color="primary">
        Group 2 User Activity
      </Button>
    </Stack>
  </ReferralRouteShell>
);

export default AdminIndexPage;
